import { haveFilterQuery, haveSort, paginator } from '../../common/auxFun'

const endpointsNeeds = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/purchases/needs${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  CREATE: (filter, sort, limit, skip) =>
    `/v1/purchases/needs${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_ID: (id) => `/v1/purchases/needs/${id}`,
  ADD_TO_CART: `/v1/purchases/needs/addToCart`,
  NEED_ADD_TO_CAR: (needId, elementId) =>
    `/v1/purchases/needs/${needId}/elementNotToCart/${elementId}`,
  ACTIVE_ALL: (needId) => `/v1/purchases/needs/${needId}/activateAll`,
  DESACTIVE_ALL: (needId) => `/v1/purchases/needs/${needId}/deactivateAll`,
}

export default endpointsNeeds
